import Breadcrumb from "../components/Breadcrumb";
import BlogsList from "../components/blog/BlogsList";
// import MasterLayout from "../masterLayout/MasterLayout";

const BlogsListPage = () => {
  return (
    // <MasterLayout>
    <>
      <Breadcrumb title="All Blogs" />
      <BlogsList />
    </>
    // </MasterLayout>
  );
};

export default BlogsListPage;

